<template>
	<div class="qiye_details">
		<ul class="qiye_details_every">
			<li class="qiye_details_list">
				<div class="qiye_details_img" :style="{'backgroundImage':'url('+enterprise.img+')'}"></div>
				<div class="qiye_details_right">
					<div>{{ enterprise.title }}</div>
					<div class="qiye_details_bottom">机构标语：<span>{{ enterprise.summary }}</span></div>
					<div class="qiye_details_bottom">机构联系方式：<span>{{ enterprise.phone }}</span></div>
					<div class="qiye_details_bottom">入驻时间：<span>{{ enterprise.created_at }}</span></div>
				</div>
			</li>
		</ul>
		<div>
			<p class="qiye_send">机构详情</p>
			<div class="qiye_details_license_img">
				<img :src="enterprise.license_img" alt="机构详情图片">
			</div>
		 </div>
	</div>
</template>
<script>
export default {
	metaInfo: {
		title: "拍界——唤醒您的沉睡资产",
		meta: [{
			name: "keywords",
			content: "拍界，拍界官网，捡漏，拍卖，手机拍卖，二手设备拍卖，废旧物资拍卖，整厂拍卖，房屋拍卖，车辆拍卖，土地拍卖，小商品拍卖"
		}, {
			name: "description",
			content: "拍界是一个专注拍卖的网络平台，拍卖无边界，拍卖更便捷。拍界，拍界官网，捡漏，拍卖，手机拍卖，二手设备拍卖，废旧物资拍卖，整厂拍卖，房屋拍卖，车辆拍卖，土地拍卖，小商品拍卖"
		}]
	},
	data (){
		return{
			enterprise: {},
			id: this.$route.query.id
		}
	 },
	 mounted: function() {

	},
	created(){
		// 请求页面数据
		this.axios.get(this.$global.apiUrl.enterprises_show, {
			params: {
				id: this.id
			}
		})
		.then((response) => {
			if(response.data.error.code == 0){
				this.enterprise = response.data.enterprise;
				console.log(response.data.enterprise)
			}else{

			}
		})
		.catch(() => {
				// console.log(response.data.error.message)
		})
	},
	computed: {

	}
}
</script>